import FJImageEnhancerCardContainer from '../container/FJImageEnhancerCardContainer';
import FJImageManipulationInputContainer from '../container/FJImageManipulationInputContainer';
import FJSwitchCard from './FJSwitchCard';
import styles from './FJImageManipulationLeft.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJUtil from '../../../../util/FJUtil';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import classNames from 'classnames';
import FJImageManipulationColorizerContainer from '../container/FJImageManipulationColorizerContainer';
import { IMAGE_MANIPULATION_USE_CREDIT } from '../../../../redux/slices/FJSliceImageManipulation';
import { useRef, useEffect } from 'react';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';

const FJImageManipulationLeft = props => {
    const {
        switchOldPhotoRestoration,
        onSwitchOldPhotoRestoration,
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        isProjectLoading,
        imageEnhancerActive,
    } = props;

    const scrollRef = useRef(null);

    const useCredit = IMAGE_MANIPULATION_USE_CREDIT;
    const isFree = freeNumCreation > 0 && creditNumber < useCredit;
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    const style = { width: '435px' };

    useEffect(() => {
        if (imageEnhancerActive && scrollRef.current) {
            setTimeout(() => {
                scrollRef.current.scrollTop(999, 'smooth');
            }, 200);
        }
    }, [imageEnhancerActive]);

    const defaultFreeNumCreation = useDefaultFreeLimit();

    return (
        <FJAppLeft>
            <FJImageManipulationInputContainer />
            <div className={classNames(styles.title, styles.margin_top_30)}>{FJLocalStore._('image-settings')}</div>
            <FJVerticalScroller className={styles.scroll} ref={scrollRef}>
                <FJImageManipulationColorizerContainer disabled={isDisabled} />
                <FJSwitchCard
                    text={FJLocalStore._('ai-old-photo-restoration')}
                    active={switchOldPhotoRestoration}
                    onChange={onSwitchOldPhotoRestoration}
                    disabled={isDisabled}
                    style={style}
                />

                <FJImageEnhancerCardContainer disabled={isDisabled} style={style} />
            </FJVerticalScroller>
            <div className={styles.footer}>
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    disabled={isDisabled}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                />
            </div>
        </FJAppLeft>
    );
};
FJImageManipulationLeft.propTypes = {
    switchOldPhotoRestoration: PropTypes.bool,
    onSwitchOldPhotoRestoration: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    imageEnhancerActive: PropTypes.bool,
};
export default FJImageManipulationLeft;
